exports.components = {
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-sidebar-tsx": () => import("./../../../src/pages/sidebar.tsx" /* webpackChunkName: "component---src-pages-sidebar-tsx" */)
}

